export const environment = {
  production: false,
  environmentName: 'development',
  apiBaseUrl: 'https://api-dev.codeclairvoyance.com/',
  useMockTranslations: false,
  uploadConfig: {
    inputFile: {
      accept: '.sas',
      multiple: false
    },
    sampleDataFiles: {
      accept: '.sas7bdat',
      multiple: true
    },
    expectedOutputFile: {
      accept: '.csv,.xlsx',
      multiple: false
    },
    maxTotalFileSizeBytes: 20971520
  },
  entra: {
    tenantId: '81d708e3-622e-461d-918a-4b9e4ca8cec7',
    clientId: '09cb1c1e-708f-4687-a187-23dff8e26bcd',
    redirectUri: window.location.origin,
    postLogoutRedirectUri: `${window.location.origin}/login`,
    scopes: ['openid', 'profile', 'email'],
    apiScopes: ['api://23c77ec0-6bfd-48f2-84df-bdc20fd35190/Translations.All']
  }
};
